<template>
  <div v-if="visible" class="pr-overlay">
    <div class="pr-card" :class="{ 'animate-in': startAnimation }">
      <div class="pr-icon">🏆</div>
      <div class="pr-title">Neuer Rekord!</div>
      <div class="pr-subtitle">{{ recordType }}</div>
      <div class="pr-value">{{ newValue }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersonalRecordAnimation",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    recordType: {
      type: String,
      default: "Maximalgewicht",
    },
    newValue: {
      type: String,
      default: "100 kg",
    },
  },
  data() {
    return {
      startAnimation: false,
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.startAnimation = true
          // Versteckt die Animation nach 2.5 Sekunden automatisch wieder
          setTimeout(() => {
            this.startAnimation = false
            setTimeout(() => {
              this.$emit("update:visible", false)
            }, 500)
          }, 2500)
        })
      }
    },
  },
}
</script>

<style scoped>
/* Neuer Code für PersonalRecordAnimation.vue */
.pr-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* HÖCHSTMÖGLICHER Z-INDEX, um über allen Dialogen zu schweben */
  z-index: 2147483647 !important;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  /* Sorgt für eine sanfte Einblendung des Hintergrunds */
  transition: background-color 0.3s ease, backdrop-filter 0.3s ease;
}

.pr-card {
  /* Ein "galaktischer" Hintergrund-Farbverlauf */
  background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);
  border: 2px solid;
  /* Animierter Farbverlauf für den Rand */
  border-image: linear-gradient(135deg, #ffd700, #ff8c00, #c0c0c0, #ffd700) 1;
  animation: border-pan 4s linear infinite;
  background-size: 200% 200%;
  border-radius: 24px;
  padding: 24px 32px;
  text-align: center;
  color: white;
  /* Ein intensiverer, mehrschichtiger Schatten */
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8), 0 0 40px rgba(255, 193, 7, 0.7);
  opacity: 0;
  transform: scale(0.7) rotate(5deg);
  /* Eine "federndere" Animationskurve */
  transition: opacity 0.6s cubic-bezier(0.34, 1.56, 0.64, 1), transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.pr-card.animate-in {
  opacity: 1;
  transform: scale(1) rotate(0deg);
}

.pr-icon {
  font-size: 4rem;
  line-height: 1;
  /* Ein pulsierender Leuchteffekt für das Icon */
  text-shadow: 0 0 15px #ffd700, 0 0 25px #ff8c00;
  animation: icon-pop-in 0.6s 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275) backwards, icon-glow 2s 1s infinite alternate;
}

.pr-title {
  font-size: 2.2rem;
  font-weight: 900;
  margin-top: 16px;
  /* Schimmernder Text-Effekt */
  background: linear-gradient(90deg, #ffffff, #ffd700, #ffffff);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: text-shine 3s linear infinite;
}

.pr-subtitle {
  font-size: 1rem;
  font-weight: 500;
  color: #bdbdbd;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.pr-value {
  font-size: 2.8rem;
  font-weight: bold;
  color: #ffd700;
  margin-top: 16px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 16px;
  padding: 8px 24px;
  display: inline-block;
  border: 1px solid rgba(255, 215, 0, 0.3);
  box-shadow: inset 0 0 15px rgba(255, 215, 0, 0.2);
}

/* --- NEUE KEYFRAME ANIMATIONEN --- */

@keyframes border-pan {
  0% {
    border-image: linear-gradient(135deg, #ffd700, #ff8c00, #c0c0c0, #ffd700) 1;
  }
  25% {
    border-image: linear-gradient(135deg, #ffd700, #ff8c00, #c0c0c0, #ffd700) 1;
    border-image-slice: 1;
    border-image-source: linear-gradient(225deg, #ffd700, #ff8c00, #c0c0c0, #ffd700);
  }
  50% {
    border-image: linear-gradient(315deg, #ffd700, #ff8c00, #c0c0c0, #ffd700) 1;
  }
  75% {
    border-image-source: linear-gradient(45deg, #ffd700, #ff8c00, #c0c0c0, #ffd700);
  }
  100% {
    border-image: linear-gradient(135deg, #ffd700, #ff8c00, #c0c0c0, #ffd700) 1;
  }
}

@keyframes text-shine {
  to {
    background-position: 200% center;
  }
}

@keyframes icon-pop-in {
  from {
    transform: scale(0.5) rotate(-45deg);
    opacity: 0;
  }
  to {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}

@keyframes icon-glow {
  from {
    text-shadow: 0 0 15px #ffd700, 0 0 25px #ff8c00;
  }
  to {
    text-shadow: 0 0 25px #ffd700, 0 0 40px #ff8c00;
  }
}
</style>
